import Trapezoid from '@assets/images/Shapes/Trapezoid.png'
import Circle from '@assets/images/Shapes/Circle.png'
import Octagon from '@assets/images/Shapes/Octagon.png'
import Archa from '@assets/images/Shapes/Archa (1).png'
import Archa1 from '@assets/images/Shapes/Archa 1 (1).png'
import Archa2 from '@assets/images/Shapes/Archa 2 (1).png'
import Asal from '@assets/images/Shapes/Asal (1).png'
import Asal1 from '@assets/images/Shapes/Asal 1 (1).png'
import Asal2 from '@assets/images/Shapes/Asal 2 (1).png'
import MebelShablon1 from '@assets/images/Shapes/MebelShablon1.jpg'
import MebelShablon2 from '@assets/images/Shapes/MebelShablon2.jpg'
import MebelShablon3 from '@assets/images/Shapes/MebelShablon3.jpg'
import MebelShablon4 from '@assets/images/Shapes/MebelShablon4.jpg'
import MebelShablon5 from '@assets/images/Shapes/MebelShablon5.jpg'
import MebelShablon6 from '@assets/images/Shapes/MebelShablon6.jpg'
import MebelShablon7 from '@assets/images/Shapes/MebelShablon7.jpg'
import MebelShablon8 from '@assets/images/Shapes/MebelShablon8.jpg'
import MebelShablon9 from '@assets/images/Shapes/MebelShablon9.jpg'
import MebelShablon10 from '@assets/images/Shapes/MebelShablon10.jpg'
import Triangle from '@assets/images/Shapes/Triangle.png'
import Triangle01 from '@assets/images/Shapes/Triangle01.png'
import Triangle02 from '@assets/images/Shapes/Triangle02.png'
import Pentagon from '@assets/images/Shapes/Pentagon.png'
import Qalam from '@assets/images/Shapes/Qalam (1).png'
import Qalam01 from '@assets/images/Shapes/Qalam01 (1).png'
import Qalam02 from '@assets/images/Shapes/Qalam02 (1).png'
import Qombik from '@assets/images/Shapes/Qombik.png'
import Qombik1 from '@assets/images/Shapes/Qombik1.png'
import Qombik2 from '@assets/images/Shapes/Qombik2.png'
import TelefonBurchak from '@assets/images/Shapes/TelefonBurchak.jpg'
import TelefonBurchak1 from '@assets/images/Shapes/TelefonBurchak1.jpg'
import TelefonBurchak2 from '@assets/images/Shapes/TelefonBurchak2.jpg'
import TelefonBurchak3 from '@assets/images/Shapes/TelefonBurchak3.jpg'
import VorobskoyChizma from '@assets/images/Shapes/VorobskoyChizma.jpg'
import AsalChizma from '@assets/images/Shapes/AsalChizma.jpg'
import OlmosChizma from '@assets/images/Shapes/OlmosChizma.jpg'
import RombikChizma from '@assets/images/Shapes/RombikChizma.jpg'
import ArchaChizma from '@assets/images/Shapes/ArchaChizma.jpg'
import KirpichChizma from '@assets/images/Shapes/KirpichChizma.jpg'
import QalamChizma from '@assets/images/Shapes/QalamChizma.jpg'
import RombikTumachaliChizma from '@assets/images/Shapes/RombikTumachaliChizma.jpg'

import Gradus90RazvijnoyDush from '@assets/images/Shapes/90GRADUS_RAZVIJNOY_DUSH.png'
import Gradus90RazvijnoyDushBurchak from '@assets/images/Shapes/90 GRADUS BURCHAK  RAZVIJNOY DUSH.png'
import Gradus90CheburashkaDush from '@assets/images/Shapes/90 GRADUS CHEBURASHKA DUSH.png'
import Gradus135Dush from '@assets/images/Shapes/135 GRADUS DUSH.png'
import AptekaAkoshka from '@assets/images/Shapes/APTEKA AKOSHKA PNG.png'
import AzinViriz from '@assets/images/Shapes/AZN VIRIZ PNG.png'
import BankAkoshka from '@assets/images/Shapes/BANK AKOSHKA PNG.png'
import BurchakViriz1X from '@assets/images/Shapes/BURCHAK VIRIZ 1X.png'
import BurchakViriz2X from '@assets/images/Shapes/BURCHAK VIRIZ 2X.png'
import CentrZamok from '@assets/images/Shapes/CENTR ZAMOK PNG.png'
import FORTUCHKA_BANAN_PETLYA from '@assets/images/Shapes/FORTUCHKA BANAN PETLYA.png'
import FORTUCHKA_CHEBURASHKA_PETLYA from '@assets/images/Shapes/FORTUCHKA CHEBURASHKA PETLYA.png'
import FORTUSHKA from '@assets/images/Shapes/FORTUSHKA PNG.png'
import FORTUSHKA_2X from '@assets/images/Shapes/FORTUSHKA 2X PNG.png'
import GULSHAN_VIRIZ1 from '@assets/images/Shapes/GULSHAN VIRIZ 1.png'
import GULSHAN_VIRIZ from '@assets/images/Shapes/GULSHAN VIRIZ.png'
import GULSHAN_VIRIZ_ESHIK from '@assets/images/Shapes/GULSHAN VIRIZ ESHIK.png'
import GULSHAN_ZAMOK from '@assets/images/Shapes/GULSHAN ZAMOK.png'
import Kirpich1 from '@assets/images/Shapes/Kirpich 2 (1).png'
import ORTA_VIRIZ from '@assets/images/Shapes/O`RTA VIRIZ.png'
import Oval from '@assets/images/Shapes/Oval.png'
import Oval01 from '@assets/images/Shapes/Oval01.png'
import Oval02 from '@assets/images/Shapes/Oval02.png'
import Parallelogram from '@assets/images/Shapes/Parallelogram.png'
import PATALOJ_RAZVIJNOY from '@assets/images/Shapes/PATALOJ RAZVIJNOY.png'
import Pencil from '@assets/images/Shapes/Pencil.png'
import PEREGARODKA from '@assets/images/Shapes/PEREGARODKA.png'
import PRIMOY_CHEBURASHKA_DUSH from '@assets/images/Shapes/PRIMOY CHEBURASHKA DUSH.png'
import PRIMOY_RAZVIJNOY_DUSH_2 from '@assets/images/Shapes/PRIMOY RAZVIJNOY DUSH 2.png'
import PRIMOY_RAZVIJNOY_DUSH from '@assets/images/Shapes/PRIMOY RAZVIJNOY DUSH.png'
import RAZETKA_VIRIZ_1X from '@assets/images/Shapes/RAZETKA VIRIZ 1X.png'
import RAZETKA_VIRIZ_2X from '@assets/images/Shapes/RAZETKA VIRIZ 2X.png'
import RAZETKA_VIRIZ_3X from '@assets/images/Shapes/RAZETKA VIRIZ 3X.png'
import RAZETKA_VIRIZ_4X from '@assets/images/Shapes/RAZETKA VIRIZ 4X.png'
import Rectangle from '@assets/images/Shapes/Rectangle.png'
import Rectangle02 from '@assets/images/Shapes/Rectangle02.png'
import Rombus from '@assets/images/Shapes/Rhombus.png'
import SELECO_VIRIZ_ESHIK from '@assets/images/Shapes/SELECO VIRIZ ESHIK.png'
import SELECO_VIRIZ from '@assets/images/Shapes/SELECO VIRIZ.png'
import SELECO_ZAMOK from '@assets/images/Shapes/SELECO ZAMOK.png'
import Semicircle from '@assets/images/Shapes/Semicircle.png'
import TABLETKA_VIRIZ from '@assets/images/Shapes/TABLETKA VIRIZ.png'
import VITRAJ_SELECO_1_TAVAQA from '@assets/images/Shapes/VITRAJ SELECO 1 TAVAQA.png'
import VITRAJ_SELECO_2_TAVAQA from '@assets/images/Shapes/VITRAJ SELECO 2 TAVAQA.png'
import ZINA_VIRIZ from '@assets/images/Shapes/ZINA VIRIZ.png'

export const generateImage = (itemCode) => {
	switch (itemCode) {
		case 'Triangle':
			return Triangle
		case 'Triangle01':
			return Triangle01
		case 'Triangle02':
			return Triangle02
		case 'Trapezoid':
			return Trapezoid
		case 'Rectangle':
			return Rectangle
		case 'Rectangle02':
			return Kirpich1
		case 'Rectangle01':
			return Rectangle02
		case 'Square':
			return Rectangle
		case 'Rhombus':
			return Rombus
		case 'Circle':
			return Circle
		case 'Octagon':
			return Octagon
		case 'SemiCircle':
			return Semicircle
		case 'Oval':
			return Oval
		case 'Oval01':
			return Oval01
		case 'Oval02':
			return Oval02
		case 'Parallelogram':
			return Parallelogram
		case 'Pencil':
			return Pencil
		case 'Archa':
			return Archa
		case 'Archa01':
			return Archa1
		case 'Archa02':
			return Archa2
		case 'Asal':
			return Asal
		case 'Asal01':
			return Asal1
		case 'Asal02':
			return Asal2
		case 'MebelShablon1':
			return MebelShablon1
		case 'MebelShablon2':
			return MebelShablon2
		case 'MebelShablon3':
			return MebelShablon3
		case 'MebelShablon4':
			return MebelShablon4
		case 'MebelShablon5':
			return MebelShablon5
		case 'MebelShablon6':
			return MebelShablon6
		case 'MebelShablon7':
			return MebelShablon7
		case 'MebelShablon8':
			return MebelShablon8
		case 'MabelShablon9': // Itemcodeni imloviy xato bn yozib qoyishgan SAP da
			return MebelShablon9
		case 'MebelShablon10':
			return MebelShablon10
		case 'Pentagon':
			return Pentagon
		case 'Qalam':
			return Qalam
		case 'Qalam01':
			return Qalam01
		case 'Qalam02':
			return Qalam02
		case 'Qombik':
			return Qombik
		case 'Qombik1':
			return Qombik1
		case 'Qombik2':
			return Qombik2
		case 'TelefonBurchak':
			return TelefonBurchak1
		case 'TelefonBurchak1':
			return TelefonBurchak2
		case 'TelefonBurchak 2':
			return TelefonBurchak3
		case 'TelefonBurchak3':
			return TelefonBurchak
		case 'VorobskoyChizma':
			return VorobskoyChizma
		case 'AsalChizma':
			return AsalChizma
		case 'OlmosChizma':
			return OlmosChizma
		case 'RombikChizma':
			return RombikChizma
		case 'ArchaChizma':
			return ArchaChizma
		case 'KirpichChizma':
			return KirpichChizma
		case 'QalamChizma':
			return QalamChizma
		case 'RombikTumachaliChizma':
			return RombikTumachaliChizma

		// 🔹 New Shape Mappings (From Your Table)
		case 'BCH-V1':
			return BurchakViriz1X
		case 'BCH-V2':
			return BurchakViriz2X
		case 'AZN-V1':
			return AzinViriz
		case 'ZNA-V1':
			return ZINA_VIRIZ
		case 'ORT-V1':
			return ORTA_VIRIZ
		case 'APK-W1':
		case 'APK-W2':
			return AptekaAkoshka
		case 'FRT-V1':
			return FORTUSHKA
		case 'FRT-V2':
			return FORTUSHKA_2X
		case 'RZT-V1':
			return RAZETKA_VIRIZ_1X
		case 'RZT-V2':
			return RAZETKA_VIRIZ_2X
		case 'RZT-V3':
			return RAZETKA_VIRIZ_3X
		case 'RZT-V4':
			return RAZETKA_VIRIZ_4X
		case 'TBL-V1':
			return TABLETKA_VIRIZ
		case 'CTR-L1':
			return CentrZamok
		case 'GLS-V1':
			return GULSHAN_VIRIZ
		case 'GLS-L1':
			return GULSHAN_ZAMOK
		case 'SLC-V1':
			return SELECO_VIRIZ
		case 'SLC-Z1':
			return SELECO_ZAMOK

		// 🔹 DUSH (Shower) items
		case 'DSH-B90':
			return Gradus90RazvijnoyDushBurchak
		case 'DSH-C90':
			return Gradus90CheburashkaDush
		case 'DSH-G135':
			return Gradus135Dush
		case 'DSH-PC1':
			return PRIMOY_CHEBURASHKA_DUSH
		case 'DSH-PR1':
			return PRIMOY_RAZVIJNOY_DUSH
		case 'DSH-PR2':
			return PRIMOY_RAZVIJNOY_DUSH_2
		case 'DSH-R90':
			return Gradus90RazvijnoyDush

		// 🔹 FORTUCHKA
		case 'FRT-BP':
			return FORTUCHKA_BANAN_PETLYA
		case 'FRT-CP':
			return FORTUCHKA_CHEBURASHKA_PETLYA

		// 🔹 GULSHAN & SELECO variants
		case 'GLS-VE':
			return GULSHAN_VIRIZ_ESHIK
		case 'SLC-VE':
			return SELECO_VIRIZ_ESHIK

		// 🔹 Other
		case 'PRG-1':
			return PEREGARODKA
		case 'PTL-R1':
			return PATALOJ_RAZVIJNOY
		case 'VTJ-S1T':
			return VITRAJ_SELECO_1_TAVAQA
		case 'VTJ-S2T':
			return VITRAJ_SELECO_2_TAVAQA

		default:
			break
	}
}
